import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';

import { Box } from '@parspec/pixel';

export const MultiFactorAuthVerification = () => {
    const navigate = useNavigate();



    useEffect(() => {
        const twoFactorSettingsFromLs = localStorage.getItem('two_factor_settings') ? JSON.parse(localStorage.getItem('two_factor_settings') as string) : '';
        if (!twoFactorSettingsFromLs) {
            navigate('/login');
            return;
        }
    }, []);

    return (
        <Box
            width="100vw"
            height="100vh"
            bgcolor="#091535"
            sx={{
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundImage: `url(assets/images/login/login-bg.png) `
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                <>
                    <Box display="flex" alignItems="center" mb={6}>
                        <Box height="45px" width="45px" mr={3}>
                            <img src={'assets/images/login/vector.png'} alt="parspec-logo" />
                        </Box>

                        <Box>
                            <img src={'assets/images/login/parspec.png'} alt="parspec-text" vertical-align="middle" />
                        </Box>
                    </Box>
                    <Outlet />
                </>
            </Box>
        </Box>
    );
};
